import { Component, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription, Subscribable } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { TaxLinesBus } from '@app/cp/shared/models/TaxLinesBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'tax-lines',
    templateUrl: './tax-lines.component.html',
    styleUrls: ['./tax-lines.component.scss']
})
export class TaxLinesComponent extends BaseGridEditLineComponent<TaxLinesBus, null, null>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
//        this.svc_data = svc_data;
        this.className = "TaxLinesBus";
        this.saveMode = SaveMode.all;
        this.appCode = "TaxLines";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'taxLineId': new UntypedFormControl(),
            'companyId': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
            'rate': new UntypedFormControl(),
            'taxLineName': new UntypedFormControl('', Validators.required),
            'supplierId': new UntypedFormControl('', Validators.required),
            'isTaxLabor': new UntypedFormControl(),
            'isTaxMaterial': new UntypedFormControl(),
            'isTaxOther': new UntypedFormControl(),
            'taxCodeTaxLineXREFId': new UntypedFormControl(),
            'supplierName': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserid': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'qbid': new UntypedFormControl(),
            'qbeditSequenceId': new UntypedFormControl()
        });
        this.disableCpSearchDialog();
    }

    setForm() {
        this.editForm.patchValue({
            taxLineId: this.selectedData.taxLineId,
            companyId: this.selectedData.companyId,
            isActive: this.selectedData.isActive,
            rate: this.selectedData.rate,
            taxLineName: this.selectedData.taxLineName,
            supplierId: this.selectedData.supplierId,
            isTaxLabor: this.selectedData.isTaxLabor,
            isTaxMaterial: this.selectedData.isTaxMaterial,
            isTaxOther: this.selectedData.isTaxOther,
            taxCodeTaxLineXREFId: this.selectedData.taxCodeTaxLineXREFId,
            supplierName: this.selectedData.supplierName,
            insertDt: this.selectedData.insertDt,
            insertUserid: this.selectedData.insertUserid,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            qbid: this.selectedData.qbid,
            qbeditSequenceId: this.selectedData.qbeditSequenceId
        });
    }
    suppliersInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }

    setFromReferenceData(data: TaxLinesBus) {
        data.supplierName = this.referenceData.getSupplierName(data.supplierId);
        return data;
    }

}
